import { render } from "./EstrattiContoDetail.vue?vue&type=template&id=b5b1f39a&scoped=true"
import script from "./EstrattiContoDetail.vue?vue&type=script&lang=js"
export * from "./EstrattiContoDetail.vue?vue&type=script&lang=js"

import "./EstrattiContoDetail.vue?vue&type=style&index=0&id=b5b1f39a&scoped=true&lang=css"
import "./EstrattiContoDetail.vue?vue&type=style&index=1&id=b5b1f39a&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b1f39a"]])

export default __exports__